import React, { useState } from "react";
import Footer from "../Components/Footer";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";
import SEO from "../Components/SEO";
import { SEO_DATA } from "../config/seoData";
import { CONTACT_FAQS } from "../config/seoSchemas";
import swal from "sweetalert";
import { Link } from 'react-router-dom';
import {
  MessageCircle,
  Phone,
  Mail,
  MapPin,
  Ship,
  PartyPopper,
  Zap,
  Package,
  Briefcase,
  ArrowRight,
  ChevronDown,
} from "lucide-react";

const WHATSAPP_URL = "https://wa.me/918591993301";
const PRIMARY_PHONE = "+918591993301";

const serviceCards = [
  {
    title: "Private Yacht Charters",
    icon: Ship,
    type: "Private Yacht Charters",
    link: "/private-yacht-charter-mumbai-goa",
  },
  {
    title: "Yacht Parties & Celebrations",
    icon: PartyPopper,
    type: "Yacht Parties & Celebrations",
    link: "/yacht-party-mumbai",
  },
  {
    title: "Speed Boat Transfers",
    icon: Zap,
    type: "Speed Boat Transfers",
    link: "/SpeedBoat",
  },
  {
    title: "Curated Packages",
    icon: Package,
    type: "Curated Packages",
    link: "/packages",
  },
  {
    title: "Corporate Events",
    icon: Briefcase,
    type: "Corporate Events",
    link: "/CorporateEvents",
  },
];

const experienceOptions = [
  "Private Yacht Charters",
  "Yacht Parties & Celebrations",
  "Speed Boat Transfers",
  "Curated Packages",
  "Corporate Events",
  "Other / Not Sure",
];

export default function Contact() {
  const [activeFaq, setActiveFaq] = useState(null);
  const [experienceType, setExperienceType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const scrollToForm = (type = "") => {
    if (type) {
      setExperienceType(type);
    }
    document.getElementById("ibcnt-form")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    const form = event.target;
    const formData = new FormData(form);

    const summary = [
      `Name: ${formData.get("name")}`,
      `Mobile: ${formData.get("mobile")}`,
      `Date: ${formData.get("date")}`,
      `Guests: ${formData.get("guests")}`,
      `Experience: ${formData.get("experienceType")}`,
      `Requirement: ${formData.get("requirement")}`,
    ].join("\n");

    try {
      await swal(
        "Enquiry Received",
        "Thank you. Our team will review your requirement and share suitable options shortly.",
        "success"
      );
      form.reset();
      setExperienceType("");
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }

    console.info("Contact enquiry:", summary);
  };

  return (
    <>
      <SEO {...SEO_DATA.contact} />

      <IndiaBoatsTopBar />
      <PremiumNavbar />

      <section className="ibcnt-hero">
        <div className="ibcnt-hero-inner">
          <div className="ibcnt-hero-copy">
            <span className="ibcnt-eyebrow">Get In Touch</span>
            <h1 className="ibcnt-hero-title">Contact Indiaboats</h1>
            <div className="ibcnt-hero-divider" />
            <p className="ibcnt-hero-text">
              Planning a yacht charter, speed boat transfer, celebration or
              corporate event? Tell us your date, guest count and requirement,
              and our team will help you choose the right option.
            </p>
            <div className="ibcnt-hero-actions">
              <a
                href={WHATSAPP_URL}
                className="ibcnt-btn ibcnt-btn-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                <MessageCircle size={18} />
                WhatsApp Us
              </a>
              <a href={`tel:${PRIMARY_PHONE}`} className="ibcnt-btn ibcnt-btn-secondary">
                <Phone size={18} />
                Call Now
              </a>
              <button
                type="button"
                className="ibcnt-btn ibcnt-btn-outline"
                onClick={() => scrollToForm()}
              >
                Send Enquiry
                <ArrowRight size={18} />
              </button>
            </div>
          </div>

          <div className="ibcnt-form-panel" id="ibcnt-form">
            <div className="ibcnt-form-card">
              <span className="ibcnt-form-label">Send Us Your Requirement</span>
              <h2 className="ibcnt-form-title">Get Options</h2>
              <p className="ibcnt-form-subtext">
                Share your plan and we will recommend the best yacht, boat or
                package for your date and group size.
              </p>

              <form className="ibcnt-form" onSubmit={handleSubmit}>
                <div className="ibcnt-form-grid">
                  <div className="ibcnt-field">
                    <label htmlFor="ibcnt-name">Name</label>
                    <input
                      id="ibcnt-name"
                      name="name"
                      type="text"
                      placeholder="Your full name"
                      required
                    />
                  </div>
                  <div className="ibcnt-field">
                    <label htmlFor="ibcnt-mobile">Mobile Number</label>
                    <input
                      id="ibcnt-mobile"
                      name="mobile"
                      type="tel"
                      placeholder="+91 XXXXX XXXXX"
                      required
                    />
                  </div>
                  <div className="ibcnt-field">
                    <label htmlFor="ibcnt-date">Preferred Date</label>
                    <input id="ibcnt-date" name="date" type="date" required />
                  </div>
                  <div className="ibcnt-field">
                    <label htmlFor="ibcnt-guests">Number of Guests</label>
                    <input
                      id="ibcnt-guests"
                      name="guests"
                      type="number"
                      min="1"
                      placeholder="e.g. 8"
                      required
                    />
                  </div>
                  <div className="ibcnt-field ibcnt-field-full">
                    <label htmlFor="ibcnt-experience">Experience Type</label>
                    <select
                      id="ibcnt-experience"
                      name="experienceType"
                      value={experienceType}
                      onChange={(event) => setExperienceType(event.target.value)}
                      required
                    >
                      <option value="" disabled>
                        Select experience type
                      </option>
                      {experienceOptions.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="ibcnt-field ibcnt-field-full">
                    <label htmlFor="ibcnt-requirement">Requirement Details</label>
                    <textarea
                      id="ibcnt-requirement"
                      name="requirement"
                      rows="4"
                      placeholder="Tell us about your occasion, route, timing or any special requests"
                      required
                    />
                  </div>
                </div>
                <button
                  type="submit"
                  className="ibcnt-submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Sending..." : "Get Options"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <section className="ibcnt-services">
        <div className="ibcnt-container">
          <div className="ibcnt-section-head">
            <span className="ibcnt-eyebrow">Our Experiences</span>
            <h2 className="ibcnt-section-title">What Can We Help You With</h2>
            <p className="ibcnt-section-text">
              Choose an experience category and send your enquiry. Our team will
              guide you to the right yacht, boat or package.
            </p>
          </div>

          <div className="ibcnt-services-grid">
            {serviceCards.map((card) => {
              const Icon = card.icon;
              return (
                <article className="ibcnt-service-card" key={card.title}>
                  <div className="ibcnt-service-icon">
                    <Icon size={24} />
                  </div>
                  <h3 className="ibcnt-service-title">{card.title}</h3>
                  <div className="ibcnt-service-actions">
                  <div className="ibcnt-service-actions">
  <Link to={card.link} className="ibcnt-service-btn"> {/* Use 'href={card.link}' if using Next.js */}
    Enquire Now
    <ArrowRight size={16} />
  </Link>
</div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <section className="ibcnt-details">
        <div className="ibcnt-container">
          <div className="ibcnt-section-head ibcnt-section-head-light">
            <span className="ibcnt-eyebrow ibcnt-eyebrow-light">Reach Us</span>
            <h2 className="ibcnt-section-title ibcnt-section-title-light">
              Contact Details
            </h2>
          </div>

          <div className="ibcnt-details-grid">
            <div className="ibcnt-detail-card">
              <div className="ibcnt-detail-icon">
                <Phone size={22} />
              </div>
              <h3>Phone / WhatsApp</h3>
              <div className="ibcnt-detail-links">
                <a href="tel:+918591993301">+91 85919 93301</a>
                <a href="tel:+919004013301">+91 90040 13301</a>
                <a href="tel:+918591983301">+91 85919 83301</a>
              </div>
            </div>

            <div className="ibcnt-detail-card">
              <div className="ibcnt-detail-icon">
                <Mail size={22} />
              </div>
              <h3>Email</h3>
              <div className="ibcnt-detail-links">
                <a href="mailto:customercare@indiaboats.in">
                  customercare@indiaboats.in
                </a>
              </div>
            </div>

            <div className="ibcnt-detail-card ibcnt-detail-card-wide">
              <div className="ibcnt-detail-icon">
                <MapPin size={22} />
              </div>
              <h3>Office</h3>
              <p>
                803, Hubtown Viva, Western Express Highway, Jogeshwari East,
                Mumbai – 400060
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="ibcnt-faq">
        <div className="ibcnt-container">
          <div className="ibcnt-section-head">
            <span className="ibcnt-eyebrow">Common Questions</span>
            <h2 className="ibcnt-section-title">Frequently Asked Questions</h2>
          </div>

          <div className="ibcnt-faq-list">
            {CONTACT_FAQS.map((item, index) => {
              const isOpen = activeFaq === index;
              return (
                <div
                  key={item.question}
                  className={`ibcnt-faq-item${isOpen ? " is-open" : ""}`}
                >
                  <button
                    type="button"
                    className="ibcnt-faq-question"
                    onClick={() => setActiveFaq(isOpen ? null : index)}
                    aria-expanded={isOpen}
                  >
                    <span>{item.question}</span>
                    <ChevronDown size={20} className="ibcnt-faq-chevron" />
                  </button>
                  <div className="ibcnt-faq-answer">
                    <p>{item.answer}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="ibcnt-cta">
        <div className="ibcnt-container">
          <div className="ibcnt-cta-card">
            <span className="ibcnt-cta-badge">Let&apos;s Plan Your Experience</span>
            <h2 className="ibcnt-cta-title">
              Tell us what you are planning
            </h2>
            <p className="ibcnt-cta-text">
              Tell us what you are planning and we&apos;ll help you find the right
              yacht, boat or package.
            </p>
            <div className="ibcnt-cta-actions">
              <a
                href={WHATSAPP_URL}
                className="ibcnt-btn ibcnt-btn-light"
                target="_blank"
                rel="noopener noreferrer"
              >
                <MessageCircle size={18} />
                WhatsApp Us
              </a>
              <a href={`tel:${PRIMARY_PHONE}`} className="ibcnt-btn ibcnt-btn-ghost">
                <Phone size={18} />
                Call Now
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
